import { preview } from '@/components/form/preview'
import { Header } from './components/Header'
import * as Texts from '../../intl'
import { Props } from './typings'

export function SingleView(props: Props) {
  const { simulation } = props

  if (!simulation) {
    return null
  }
  const { name, label } = simulation

  return (
    <preview.Root applyPendingFitMapOnMount header={<Header simulation={simulation} />}>
      <preview.Field label={Texts.getSimulationNameFieldText()}>
        <preview.Value>{name}</preview.Value>
      </preview.Field>
      <preview.Field label={Texts.getSimulationLabelFieldText()}>
        <preview.Value>{!label || label.trim() === '' ? '-' : label}</preview.Value>
      </preview.Field>
    </preview.Root>
  )
}
